// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"674":"4e99e732","787":"ae44732b"}[chunkId] + ".chunk.js";
};